import React from "react";

import { useCanUseOperator } from "@services/useCanUseOperator";

import type { BrazeOperatorLaunchButtonProps } from "../BrazeOperatorLaunchButton/types";
import { BrazeOperatorLaunchButton } from "../BrazeOperatorLaunchButton";

/**
 * This is a wrapper around the BrazeOperatorLaunchButton component that will only
 * render the button if the user has access to the Operator feature.
 */
export const BrazeOperatorLaunchButtonWithFeatureFlipper = (props: BrazeOperatorLaunchButtonProps) => {
  const canUseOperator = useCanUseOperator();

  if (!canUseOperator) {
    return null;
  }

  return <BrazeOperatorLaunchButton {...props} />;
};
